import { Box, Typography } from '@mui/material'
import SliderNavButtons from './SliderNavButtons'

/**
 * Carousel section header: title left, nav top-right on sm+.
 * Pair with SectionCarouselFooterNav for mobile bottom-center nav.
 */
export default function SectionCarouselHeader({
  title,
  titleSx = {},
  onPrev,
  onNext,
  prevDisabled,
  nextDisabled,
  headerSx = {},
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: { xs: 'flex-start', sm: 'center' },
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 3, sm: 2 },
        mb: { xs: '32px', md: '80px' },
        ...headerSx,
      }}
    >
      <Typography component="h2" sx={titleSx}>
        {title}
      </Typography>
      <SliderNavButtons
        onPrev={onPrev}
        onNext={onNext}
        prevDisabled={prevDisabled}
        nextDisabled={nextDisabled}
        sx={{ display: { xs: 'none', sm: 'flex' }, flexShrink: 0 }}
      />
    </Box>
  )
}

export function SectionCarouselFooterNav({
  onPrev,
  onNext,
  prevDisabled,
  nextDisabled,
  sx = {},
}) {
  return (
    <Box
      sx={{
        display: { xs: 'flex', sm: 'none' },
        justifyContent: 'center',
        ...sx,
      }}
    >
      <SliderNavButtons
        onPrev={onPrev}
        onNext={onNext}
        prevDisabled={prevDisabled}
        nextDisabled={nextDisabled}
      />
    </Box>
  )
}
